import React, {useEffect, useState} from 'react';
import styled from '@emotion/styled';
import {Link, useHistory} from 'react-router-dom';
import {formatPrice} from '../../helpers/Helper';
import {connect} from 'react-redux';
import {isLoggedInCustomer} from '../../utils/auth';
import {addToCart, getCatalogueProduct, getResourceFile} from '../../network';
import {setCart} from '../../redux/actions/CartActions';

import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import DropdownContainer from './DropdownComponent';

const Container = styled.div`
    width: auto;
`;
const DetailWrapper = styled.div`
    display:grid;
    grid-template-columns: 1fr auto;
    grid-gap:6rem;
    height: 45rem;

    @media (max-width: 768px){
        grid-template-columns: auto;
        grid-template-rows: 1fr auto;
        grid-gap: 2rem;
}
`;
const DetailContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: auto;

    h1{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: var(--font-20);
        line-height: var(--space-28);

        color: #232323;
    }
    span{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: var(--font-16);
        line-height: var(--space-20);

        color: #969696;
    }
    p{
        display: flex;
        flex-direction: row;
        width: 11rem;
        justify-content: space-between;
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: var(--font-16);
        line-height: var(--space-20);

        color: var(--color-neutral-gray-500);
    }
    .price{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: var(--font-24);
        line-height: var(--space-28);
        
        color: #3182CE;
    }
    .stock{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: var(--font-18);
        line-height: var(--space-20);
        
        color: var(--color-green-700);
    }

    @media (max-width: 500px){

        h1{
            font-weight: 500;
            font-size: var(--font-16);
        }
     
    }
`;
const MainImageContainer = styled.div`
    height: 25rem;
    width: 25rem;


    background: #FFFFFF;

    align-items: center;
    border: 1px solid var(--color-gray-300);
    box-sizing: border-box;
    border-radius: var(--space-8);
    overflow: hidden;
    img{
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    video{
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    @media (max-width: 768px){
        border: 1px solid transparent;
        align-self: center;
        width: 12.5rem;
        height: 12.5rem;
    }
`;

const OptionContainer = styled.div`
    margin-top:-1.5rem;
    display:flex;
    flex-direction:row;
    width:10.5rem;
    justify-content:space-between;
`;
const SlideshowWrapper = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:space-between;
    height:85%;

    p{
        align-self:center;
    }
    h2{
        cursor:pointer;
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: var(--font-18);
        line-height: var(--space-20);

        text-align: center;
        text-decoration-line: underline;



        color: #049CBE;
    }

    @media (max-width: 800px){
        h2{
            padding-top: 1rem;
        }
    }
`;
const SlideShowContainer = styled.div`
    display:grid;
    grid-auto-flow:column;
    grid-gap:0.1rem;
`;
const ThumbnailItem = styled.div`
    display: flex;

    width: 4.5rem;
    height: 4rem;

    background: white;

    border: ${props => props.selected ? '1px solid var(--company-dark)' : '1px solid #B8B8B8'};
    box-sizing: border-box;
    border-radius: 0.5rem;
    overflow: hidden;

    cursor: pointer;

    > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    > video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

`;
const Price = styled.div`
  display: flex;
  flex-direction: row;
  
  align-items: center;
  
  > .current {
    color: var(--color-blue-600);
    font-size: var(--font-20);
    line-height: var(--font-20);
    font-weight: 600;
    
    
  }
  
  > .strikethrough {
    color: var(--color-gray-500);
    font-size: var(--font-16);
    line-height: var(--font-16);
    font-weight: 600;
    margin-left:var(--space-4);
  }

  @media (max-width: 800px){
      margin-left: 0;
  }
`;
const QuantityStepperContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    
    width: 12rem;
    height: 2.25rem;
    
    
    margin-top: var(--space-8);
    margin-bottom: var(--space-16);
    
    border: 1px solid var(--color-gray-400);
    box-sizing: border-box;
    border-radius: var(--space-6);
    
    > input {
      width: 50%;
      height: -webkit-fill-available;
      padding: var(--space-6);
      border-radius: var(--space-6) 0 0 var(--space-6);
    }
    
    > button {
      width: 50%;
      height: -webkit-fill-available;
      color: white;
      background: var(--color-orange-500);
      border-radius: 0 var(--space-6) var(--space-6) 0;
    }
`;
const QuantityContainer = styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    height: 10.25rem;
    width: 28.625rem;

    background-color: #F7F7F7;


    border: 1px solid #B8B8B8;
    box-sizing: border-box;
    border-radius: var(--space-12);

    > *{
        padding-bottom:5px;
    }
    span{
        position: relative;
        left:-4rem;
    }
    @media (max-width: 500px){
        width: auto;
    }
`;
const Quantity = styled.select`
    display: flex;
    flex-direction: row;
    padding: var(--space-10) var(--space-16);

    position: static;
    width: 12.625rem;
    height: 2.25rem;
    left: 0px;
    top: 0px;



    background: #FFFFFF;


    border: 2px solid #969696;
    box-sizing: border-box;
    border-radius: var(--space-6);
    margin-bottom:var(--space-10);
`;
const AddButton = styled.button`
    display: flex;
    flex-direction: row;
    padding: var(--space-10) 3.5rem;
    width: 12.625rem;
    height: 2.25rem;


    background-color: #ED8936;
    box-shadow: 0px 4px 6px rgba(156, 66, 33, 0.12), 0px 2px 4px rgba(237, 137, 54, 0.32);
    border-radius: 6px;
    font-family: Inter,sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: var(--font-16);
    line-height: var(--space-18);
    white-space:nowrap;
    color:var(--color-white);
    transition:background-color 0.3s ease-in;

    &:hover{
        background-color:var(--color-orange-400);
    }

    &:disabled {
        cursor:default;
        background: var(--color-gray-400);
        box-shadow: none;
    }
`;
const SelectionText = styled.span`
    font-family:Inter, sans-serif;
    font-weight: 500;
    font-size: var(--font-16);
    line-height: var(--font-16);
    
    color: var(--color-red-900);
`;
const Spacer = styled.div`
    width: auto;
    justify-content: space-between;
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    margin-bottom: 2rem;

    h1{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: var(--font-32);
        line-height: 2.25rem; 
        white-space: nowrap;
    }
    button{
        width: 2.5rem;
        height: 2.5rem;
        box-sizing: border-box;
        background-color: var(--color-white);
        border-radius: var(--space-24);
        border:1px solid var(--color-gray-700);
        align-items:center;
    }
    img{
        width:2rem;
    }
    @media (max-width: 768px){
        margin-bottom: 1rem;
        button{
            left: 25rem;
            top: -0.5rem;
        }
    }
    @media (max-width: 500px){
        h1{
            padding-right: 4rem;
            font-size: var(--font-24);
        }
    }
`;
const OptionsContainer = styled.div`
    display: grid;
    grid-auto-flow:column;
    grid-gap:0.5rem;
`;

const OptionButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    
    width: 5rem;
    height: 2.25rem;
    
    color: ${props => props.disabled ? 'var(--color-gray-400)' : props.selected ? 'var(--color-green-700)' : 'var(--color-neutral-gray-900)'};
    
    font-size: var(--font-16);
    line-height: var(--font-16);
    font-weight: ${props => props.selected ? 'bold' : 'normal'};
    
    background: ${props => props.disabled ? 'var(--color-gray-100)' : props.selected ? 'var(--color-green-100)' : 'white'};
    border: ${props => props.disabled ? '1px solid var(--color-gray-300)' : props.selected ? '2px solid var(--color-green-600)' : '1px solid var(--color-neutral-gray-500)'};
    box-sizing: border-box;
    border-radius: var(--space-6);
    
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    
    &:hover {
        background: ${props => props.disabled ? 'var(--color-gray-200)' : 'var(--color-green-100)'};
    }
`;
const OptionsRow = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:space-between;
    height:4rem;
`;
const AttributeRow = styled.div`
    display: flex;
    flex-direction:row;
    align-items: center;
    
    margin-top: var(--space-20);
    margin-bottom: var(--space-20);

 
    
    > .title {
      width: var(--space-72);
      margin-right: var(--space-32);
      
      font-weight: 500;
      font-size: var(--font-16);
      line-height: var(--font-16);
      
      color: #969696;
    }


`;

const MobileOption = styled.select`
    width: 9rem;
    height: 2.25rem;

    background-color: var(--color-white);
    padding-left: 1rem;
    border: 1px solid var(--color-gray-400);
    box-sizing: border-box;
    border-radius: var(--space-6);
    -webkit-appearance: none;
    background-image: url(/icons/chevron.svg);
    background-repeat: no-repeat;
    background-position-x: 7rem;
    background-position-y:center;

`;
const MobileImageContainer = styled.div`
    display: flex;
    width: 11.45rem;
    height: 11rem;
    position: relative;
    background-color: var(--color-white);
    justify-content: center;

    border: 2px solid var(--color-gray-300);
    box-sizing: border-box;
    border-radius: var(--space-14);
    overflow: hidden;
    img{
        align-self: center;
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    video{
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
   
`;

const PlayButtonContainer = styled.div`
    display: flex;
    width: 3rem;
    height: 3rem;
    position: absolute;
    border-radius: 2rem;
    margin-top: var(--space-6);
    margin-left: var(--space-10);
    background-color: var(--color-gray-200);

    .icon{
        width: 0;
        height: 0;
        border-top: var(--space-12) solid transparent;
        border-bottom: var(--space-12) solid transparent;
        border-left: var(--space-12) solid var(--color-white);
        align-self: center;
        margin-left: var(--space-20);
        border-radius: 1rem;
        border: 2px solid var(--color-gray-500);

    }
`;

function Option({option, onOptionClick, matches,width}) {
    const {title, options} = option;
    const [selectedIndex, setSelectedIndex] = useState(0);
    let optn = ''
    const checkIfDisabled = (opt, index) => {
        if (matches.length > 0 && !matches.includes(opt)) {
            if (index === selectedIndex) {
                onOptionClick('');
                setSelectedIndex(-1);
            }
            return true;
        }
    };

    // useEffect(() =>{
    //     onOptionClick(options[0])
    // },[])


    return (
    <>
        {
            width < 800 ?
            <>
            {
                options && options.length !== 0 && <AttributeRow style={{
                    alignItems: 'baseline'
                }}>
                <span className="title">{title}:</span>
                    <MobileOption onChange={(e)=> onOptionClick(e.target.value)}>
                        {options.map((opt,index) =>{
                           
                            return <option key={`Option_${index}`}
                                    selected={index === 0}
                         >{opt}</option>
                        })}
                    </MobileOption>
                </AttributeRow>
                }
            </>
            :
            <>
            {
                options && options.length !== 0 && <OptionsRow style={{
                    alignItems: 'baseline'
                }}>
                <span className="title">{title}</span>
                <OptionsContainer>
                    {
                        options.map((opt, index) => {
                            return <OptionButton
                                key={`OptionButton_${index}`}
                                selected={selectedIndex === index}
                                disabled={checkIfDisabled(opt, index)}
                                onClick={() => {
                                    if (checkIfDisabled(opt, index)) return;

                                    onOptionClick(selectedIndex === index ? '' : opt);
                                    setSelectedIndex(selectedIndex === index ? -1 : index);
                                }}>
                                {opt}
                            </OptionButton>;
                        })
                    }
                </OptionsContainer>
                </OptionsRow>
            }
            </>

        }
    </>);
}

const DetailComponent = ({auth, setValue, item, slide, setCart, display, attr, price, showCard}) => {
    const history = useHistory();
    const [selectedMedia, setSelectedMedia] = useState({});
    const [selectedThumbnailIndex, setSelectedThumbnailIndex] = useState(0);
    const [product, setProduct] = useState(null);
    const [selectedVariant, setSelectedVariant] = useState(null);
    const [media, setMedia] = useState([]);
    const [attribute, setAttribute] = useState('');
    const [size, setSize] = useState('');
    const [isCustomQuantity, setIsCustomQuantity] = useState(false);
    const [quantity, setQuantity] = useState(1);
    const [customQuantity, setCustomQuantity] = useState(1);

    const [validAttributeOptions, setValidAttributeOptions] = useState([]);
    const [validSizeOptions, setValidSizeOptions] = useState([]);
    const [canvasWidth, setCanvasWidth] = useState(0);


    useEffect(() => {
        console.log("items"+item);
        handleResize();
    });
    const handleResize = () => {
        console.log('resized to: ', window.innerWidth, 'x', window.innerHeight);
        setCanvasWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
    };

    useEffect(() => {
        if (item?.media.length) setSelectedMedia(item?.media[selectedThumbnailIndex]);
    }, [item?.media, selectedThumbnailIndex]);

    useEffect(() => {
        //  if(isLoggedInCustomer(auth)){

        setProduct(item.product);
        console.log(product);
        // }
        const getAllMedia = () => {
            let media = [...product.media];
            product.variants.forEach(variant => {
                media.push(...variant.media);
            });
            setMedia(media);
        };
        if (product && product?.media) getAllMedia();
    }, [item]);

    useEffect(() => {
        if (product) {
            setSelectedVariant(getVariant(attribute, size));
            setValidAttributeOptions(getConfigurationCombinations('size', size));
            setValidSizeOptions(getConfigurationCombinations('attribute', attribute));

        }
    }, [attribute, size]);

    useEffect(() => {
        if (quantity !== customQuantity) setCustomQuantity(quantity);
    }, [quantity]);

    const addVariantToCart = () => {
        if (isLoggedInCustomer(auth)) {
            addToCart(auth.customer_id, auth.token, selectedVariant.id, quantity)
                .then(result => {
                    
                  
                    setCart(result);
                    
                    
                    // history.push('/cart');
                })
                .catch(error => console.error(error));
                price({
                    price: formatPrice((selectedVariant?.price * quantity) - ((selectedVariant?.price / 100) * selectedVariant?.discount) * quantity),
                    discount: formatPrice(selectedVariant?.price * quantity)
                });
               
        } else {
            // todo: redirect to login
            history.push('/login');

        }
        slide();
    };

    const handleQuantityUpdate = () => {
        setQuantity(customQuantity);
        setIsCustomQuantity(false);
    };

    const retrieveOptions = (_which) => {
        let option = {};
        if (item.product[`${_which}_name`]) {
            let list = [];
            item.product.variants.forEach((variant) => {
                if (variant[_which] && !list.includes(variant[_which])) list.push(variant[_which]);
            });

            if (list.length) {
                return {
                    title: item?.product[`${_which}_name`],
                    options: list
                };
            }
        }

        return option;
    };

    const getConfigurationCombinations = (which, value) => {
        let matches = [];
        if (which === 'attribute') {
            product.variants.forEach(variant => {
                if (variant?.attribute === value && variant?.size) matches.push(variant.size);
            });
        } else if (which === 'size') {
            product.variants.forEach(variant => {
                if (variant?.size === value && variant?.attribute) matches.push(variant.attribute);
            });
        }

        return matches;
    };

    const getVariant = (attribute, size) => {
        let productVariant = null;
        for (let i = 0; i < product?.variants.length; i++) {
            const variant = product.variants[i];
            if (attribute && size) {
                if (variant?.attribute === attribute && variant?.size === size) productVariant = variant;
            } else if (attribute) {
                if (variant?.attribute === attribute && !variant?.size) productVariant = variant;
            } else if (size) {
                if (variant?.size === size && !variant?.attribute) productVariant = variant;
            }
        }
        return productVariant;
    };

    const handleAttributeSelected = attribute => setAttribute(attribute);
    const handleSizeSelected = size => setSize(size);

    useEffect(() => {
        if(product){
            handleAttributeSelected(retrieveOptions('attribute')?.options[0])
            handleSizeSelected(retrieveOptions('size')?.options[0])
        }
    }, [product]);

    const selectedConfiguration = () => {
        let attributeString = '';
        if (product.attribute_name) {
            const {options: attributeOptions} = retrieveOptions('attribute');
            if (attribute && attributeOptions && attributeOptions.length) {
                attributeString = `${attribute} ${product.attribute_name}`;
            }
        }

        let sizeString = '';
        if (product.size_name) {
            const {options: sizeOptions} = retrieveOptions('size');
            if (size && sizeOptions && sizeOptions.length) {
                sizeString = `${size} ${product.size_name}`;
            }
        }

        if (attributeString && sizeString) {
            attr(`${attributeString} | ${sizeString}`);
            return `${attributeString} — ${sizeString}`;
        } else if (attributeString) {
            attr(`${attributeString}`);
            return attributeString;
        } else if (sizeString) {
            attr(`${sizeString}`);
            return sizeString;
        }
    };

    const priceView = (variant, quantity) => {
        const isDiscounted = variant && variant?.discount > 0 && variant?.discount_expiration > 0;

        if (isDiscounted) {
            const currentPrice = variant.price * quantity;
            const amountToDiscount = ((variant.price / 100) * variant?.discount) * quantity;
            const discountedAmount = formatPrice(currentPrice - amountToDiscount);

            return <>
                <span className="current">
                    {discountedAmount}
                </span>
                <span className="strikethrough"><s>{formatPrice(variant?.price * quantity)}</s></span>
            </>;
        } else {
            return <span className="current">
                {variant ? formatPrice(variant?.price * quantity) : '—'}
            </span>;
        }
    };

    return <Container>
        <Spacer><h1>Add Items to Cart</h1>
            <button onClick={() => {
                display(false);
                setSelectedVariant(null);
            }}>
                <img src="/icons/close_dark.svg" alt="close button"/>
            </button>
            {console.log("Its "+item?.product.name)}
        </Spacer>
        {item.product ?
            <DetailWrapper>
                
                <SlideshowWrapper>
                    {canvasWidth < 800 ?
                         <MainImageContainer>
                         <Carousel
                             dots
                         >
                          { item.media.map((item, index) =>
                             <div key={index}>
                                 {item.type === 'image' && <MobileImageContainer><img src={getResourceFile(item.resource)} alt="productItemImage"/></MobileImageContainer>}
                                 {item.type === 'video' && <MobileImageContainer><video src={getResourceFile(item.resource)}/></MobileImageContainer>}

                             </div>
                             )}
                       </Carousel>
                     </MainImageContainer>
                     :
                     <>

                        <MainImageContainer>
                            {/* <img src={props.item.image} alt="product image"/> */}
                            {selectedMedia.type === 'image' && <img src={getResourceFile(selectedMedia.resource)} alt="productImage"/>}
                            {selectedMedia.type === 'video' && <video src={getResourceFile(selectedMedia.resource)} controls/>}
                        </MainImageContainer>
                        <p>Tap or Roll Over Image</p>
                        <SlideShowContainer>
                           
                            {
                                item?.product._id !== '' ?
                                    item?.media.map((media, index) => {
                                        return <ThumbnailItem
                                            key={`ThumbnailItem_${index}`}
                                            selected={index === selectedThumbnailIndex}
                                            onClick={() => setSelectedThumbnailIndex(index)}
                                            onMouseOver={() => setSelectedThumbnailIndex(index)}
                                        >
                                            {media?.type === 'image' && <img src={getResourceFile(media?.resource)} alt="productItemImage"/>}
                                            {media?.type === 'video' && <video src={getResourceFile(media?.resource)} style={{position:"relative"}}/>}
                                            {media?.type === 'video' &&
                                                <PlayButtonContainer>
                                                    <div className="icon"></div>
                                                </PlayButtonContainer>
                                            }
                                        </ThumbnailItem>;
                                    })
                                    :
                                    null
                            }
                        </SlideShowContainer>
                    </>
                    }
                    <Link to={`/products/${item?.product._id}`}><h2>View Product Details</h2></Link>
                </SlideshowWrapper>
                <DetailContainer>
                    <h1>{`${item?.product?.brand.name + ' '} ${item?.product?.name}`}{`${selectedVariant && selectedVariant?.description ? `, ${selectedVariant?.description}` : ''}`}</h1>
                    {canvasWidth < 800 ? null
                        :    
                
                        <AttributeRow>
                            <span>Price:</span>
                            <Price style={{marginLeft:"var(--space-56)"}}>{priceView(selectedVariant, quantity)}</Price>
                        </AttributeRow>
                    }
                    <Option
                        option={retrieveOptions('attribute')}
                        matches={validAttributeOptions}
                        onOptionClick={handleAttributeSelected}
                        width={canvasWidth}
                    />

                    <Option
                        option={retrieveOptions('size')}
                        matches={validSizeOptions}
                        onOptionClick={handleSizeSelected}
                        width={canvasWidth}
                    />

                        {canvasWidth < 800 ? null

                            :

                            <AttributeRow>
                                <span className="title">Selection:</span>
                                <SelectionText>
                                    {selectedConfiguration() ? selectedConfiguration() : 'N/A'}
                                </SelectionText>
                            </AttributeRow>
                        }
                         {canvasWidth > 800 ? null :
                                <AttributeRow style={{width:"100%",justifyContent:"space-between"}}>
                                    <Price>{priceView(selectedVariant, quantity)}</Price>
                                    <span className="stock">In Stock</span>
                                </AttributeRow>
                            }
                            {canvasWidth < 800 ? null
                            :
                    <p>Availability:<span className="stock">In Stock</span></p>
                            }
                    <QuantityContainer>
                        <span>Quantity:</span>
                        {
                            (quantity > 9 || customQuantity > 9 || isCustomQuantity) ?
                                <QuantityStepperContainer>
                                    <input type="number" value={customQuantity}
                                           onChange={e => setCustomQuantity(Number(e.target.value))}/>
                                    <button onClick={handleQuantityUpdate}>Update</button>
                                </QuantityStepperContainer>
                                :
                                <DropdownContainer DropdownWidth={"12.5rem"} value={quantity} onChange={e => {
                                    const {value} = e.target;

                                    if (value === 'more') {
                                        setIsCustomQuantity(true);
                                        setCustomQuantity(quantity);
                                        setValue(quantity);
                                    } else {
                                        setQuantity(Number(value));
                                        setValue(value);
                                    }
                                }} style={{marginBottom:"0.5rem",marginTop:"0.2rem"}}>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">9</option>
                                    <option value="more">10+</option>
                                </DropdownContainer>
                        }
                        <AddButton disabled={!selectedVariant} onClick={() => addVariantToCart()}>Add To Cart</AddButton>
                    </QuantityContainer>
                </DetailContainer>
            </DetailWrapper>
            : null
        }
    </Container>;
};

const mapStateToProps = (state, props) => ({
    auth: state.auth,
    attr: props.setAttribute,
    item: props.item,
    slide: props.setSlide,
    setValue: props.setQuantity,
    user: state.user,
    cart: state.cart,
    display: props.setDisplay,
    price: props.setPrice,
    showCard: props.showCard
});

const mapDispatchToProps = {
    setCart
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailComponent);
